// ----------------------------------------------------------------------
// <copyright file="Izenda.SaveReportDesignerButton.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = require('react');
  var Button = require('share/components/controls/Izenda.Button');

  var observer = require('mobx-react').observer;
  var connect = require('share/enhancers/Izenda.Connect');
  var ACCESS_RIGHT = require('logic/data/Izenda.AuthorizationConstants').ACCESS_RIGHT;

  var SaveReportDesignerButton = function (props) {
    var localization = props.localization;
    var accessPriority = props.accessPriority;
    var saveAsPermission = props.authorization.checkPrivileges([
      props.authorizationConstants.PERMISSION_KEY.ReportsCanCreateNewReportValue
    ])
      && (accessPriority === ACCESS_RIGHT.FullAccess || accessPriority === ACCESS_RIGHT.SaveAs);

    var savePermission = props.authorization.checkPrivileges([
      props.authorizationConstants.PERMISSION_KEY.ReportsActionsOverwriteExistingReport
    ])
      && (accessPriority === ACCESS_RIGHT.FullAccess);

    var canSaveAs = props.canSaveAs;
    var canSaveGlobalReport = props.canSaveGlobalReport;
    var onSave = props.onSave;
    var onSaveAs = props.onSaveAs;

    if (canSaveGlobalReport && canSaveAs && saveAsPermission && savePermission) {
      return (
        <div className="btn-group">
          <Button
            className="btn-report-default dropdown-toggle"
            data-toggle="dropdown"
            label={localization.getText("COMMON_LABEL_SAVE")}
            disabled={props.disabled}
            >
            <span className="caret"></span>
          </Button>
          <ul className="dropdown-menu">
            <li><a onClick={onSave}>{localization.getText("COMMON_LABEL_SAVE")}</a></li>
            <li><a onClick={onSaveAs}>{localization.getText("COMMON_LABEL_SAVE_AS")}</a></li>
          </ul>
        </div>
      );
    }

    if (canSaveGlobalReport && savePermission || !props.version) {
      return (
        <Button
          onClick={onSave}
          label={localization.getText("COMMON_LABEL_SAVE")}
          className="btn-report-default"
          disabled={props.disabled}
          >
        </Button>
      );
    }

    if (canSaveAs && saveAsPermission) {
      return (
        <Button
          className="btn-report-default"
          onClick={onSaveAs}
          label={localization.getText("COMMON_LABEL_SAVE_AS")}
          disabled={props.disabled}>
        </Button>
      );
    }

    return null;
  };

  SaveReportDesignerButton.propTypes = {
    canSaveAs: React.PropTypes.bool.isRequired,
    onSave: React.PropTypes.func.isRequired,
    onSaveAs: React.PropTypes.func.isRequired
  };

  module.exports = connect()(SaveReportDesignerButton);
} ();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Toolbar/Izenda.SaveReportDesignerButton.jsx